import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBlockUser, useRemoveFriend } from '../hooks/useFriends'
import { FriendRow } from './FriendRow'
import { ReportUserModal } from './ReportUserModal'
import type { Friend } from '../types'

interface FriendListProps {
  readonly friends: Friend[]
}

export function FriendList({ friends }: FriendListProps) {
  const { t } = useTranslation()
  const [reported, setReported] = useState<Friend | null>(null)
  const remove = useRemoveFriend()
  const block = useBlockUser()

  return (
    <section aria-labelledby="social-friends-title" className="flex flex-col gap-4">
      <h2 id="social-friends-title" className="font-display text-lg font-semibold text-on-surface">
        {t('social.friends.title', { count: friends.length })}
      </h2>

      {friends.length === 0 ? (
        <div className="rounded-3xl bg-surface-low p-8 text-center">
          <p className="font-medium text-on-surface">{t('social.friends.empty')}</p>
          <p className="mt-1 text-sm text-on-surface-variant">{t('social.friends.empty_hint')}</p>
        </div>
      ) : (
        <ul className="flex flex-col gap-2">
          {friends.map((friend) => (
            <FriendRow
              key={friend.id}
              friend={friend}
              onRemove={(id) => remove.mutate(id)}
              onBlock={(id) => block.mutate(id)}
              onReport={setReported}
            />
          ))}
        </ul>
      )}

      {reported && (
        <ReportUserModal
          userId={reported.id}
          username={reported.username}
          onClose={() => setReported(null)}
        />
      )}
    </section>
  )
}
